import React from "react";
import ModalB from "react-bootstrap/Modal";
import { FaSpinner, FaUserPlus } from "react-icons/fa";

/**
 * Modal de prévia/confirmação da inclusão de participantes patrocinadores
 * nas agendas de caviar (ids 6/7 sem cota, 8 com cota).
 */
export default function ModalPreviewPatrocinadoresCaviar({
  show,
  onClose,
  onConfirmar,
  preview = null,
  loading = false,
  confirmando = false,
}) {
  const aIncluir = preview?.a_incluir || [];
  const ignorados = preview?.ignorados || [];
  const resumo = preview?.resumo || {};
  const criterioLabel =
    preview?.criterio_cota === "com_cota"
      ? "com cota de reunião"
      : "sem cota de reunião";

  return (
    <ModalB
      show={show}
      onHide={() => !confirmando && onClose?.()}
      size="lg"
      centered
      backdrop={confirmando ? "static" : true}
      dialogClassName="modal-preview-patrocinadores-caviar"
    >
      <ModalB.Header closeButton={!confirmando}>
        <ModalB.Title>
          Prévia — participantes patrocinadores (caviar)
        </ModalB.Title>
      </ModalB.Header>
      <ModalB.Body>
        {loading ? (
          <div className="apl-loading" style={{ padding: "2rem 1rem" }}>
            <FaSpinner className="fa-spin" size={28} aria-hidden />
            <span>Gerando prévia…</span>
          </div>
        ) : !preview ? (
          <div className="apl-empty" style={{ padding: "1.5rem 1rem" }}>
            <p className="apl-empty-title">Prévia indisponível</p>
            <p style={{ margin: 0 }}>Feche e tente novamente.</p>
          </div>
        ) : (
          <div className="agenda-caviar-patro-preview">
            <p className="mb-2">
              Agenda <strong>{preview.nome_agenda}</strong> (#{preview.id_agenda}
              ): participantes de patrocinadores <strong>{criterioLabel}</strong>{" "}
              com interesse na degustação de caviar.
            </p>
            <p className="mb-3 text-muted">
              Vagas: {preview.inscritos_atuais}/{preview.max_vagas} ocupadas ·{" "}
              {preview.vagas_disponiveis} disponíveis ·{" "}
              {resumo.a_incluir ?? 0} a incluir
            </p>

            <div className="agenda-caviar-patro-preview-cols">
              <section
                className="agenda-caviar-patro-preview-col"
                aria-label="Participantes a incluir"
              >
                <h3 className="agenda-caviar-patro-preview-title">
                  Serão incluídos ({aIncluir.length})
                </h3>
                {aIncluir.length === 0 ? (
                  <p className="text-muted mb-0">
                    Nenhum participante elegível para inclusão nesta sala.
                  </p>
                ) : (
                  <ul className="agenda-caviar-patro-preview-list">
                    {aIncluir.map((p) => (
                      <li key={p.id_usuario}>
                        <strong>{p.nome}</strong>
                        <span className="agenda-caviar-patro-preview-meta">
                          {[p.cargo, p.empresa || p.nome_patrocinador, p.nome_plano]
                            .filter(Boolean)
                            .join(" · ")}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </section>

              <section
                className="agenda-caviar-patro-preview-col"
                aria-label="Participantes ignorados"
              >
                <h3 className="agenda-caviar-patro-preview-title">
                  Não incluídos ({ignorados.length})
                </h3>
                {ignorados.length === 0 ? (
                  <p className="text-muted mb-0">
                    Nenhum participante foi deixado de fora.
                  </p>
                ) : (
                  <ul className="agenda-caviar-patro-preview-list agenda-caviar-patro-preview-list--muted">
                    {ignorados.map((p) => (
                      <li key={`${p.id_usuario}-${p.motivo}`}>
                        <strong>{p.nome}</strong>
                        <span className="agenda-caviar-patro-preview-meta">
                          {p.motivo}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            </div>
          </div>
        )}
      </ModalB.Body>
      <ModalB.Footer className="agenda-caviar-patro-preview-footer">
        <button
          type="button"
          className="apl-btn apl-btn--ghost"
          onClick={onClose}
          disabled={confirmando}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="apl-btn apl-btn--primary"
          onClick={onConfirmar}
          disabled={
            loading || confirmando || !preview || aIncluir.length === 0
          }
        >
          {confirmando ? (
            <FaSpinner className="fa-spin" size={14} aria-hidden />
          ) : (
            <FaUserPlus size={14} aria-hidden />
          )}
          {confirmando
            ? "Incluindo…"
            : `Confirmar inclusão (${aIncluir.length})`}
        </button>
      </ModalB.Footer>
    </ModalB>
  );
}
